import './order-search-form.scss';
import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { Controls, useFormHelpers } from 'shared/helper/form';
import { T, useTranslate } from 'shared/helper/translate';
import { convertFormDataToOrderSearchJson, convertOrderSearchJsonToFormData } from 'shared/view/order-conversion-service';
var Text = Controls.Text,
  Form = Controls.Form,
  Datepicker = Controls.Datepicker;
var defaultValues = {
  from: null,
  to: null,
  xid: '',
  orderTitle: ''
};
var OrderSearchForm = function OrderSearchForm(_ref) {
  var initialValues = _ref.initialValues,
    onSubmit = _ref.onSubmit,
    orderCount = _ref.orderCount;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  var methods = useForm({
    defaultValues: defaultValues,
    shouldFocusError: false
  });
  var _useFormHelpers = useFormHelpers(methods),
    preprocessData = _useFormHelpers.preprocessData,
    populateFormData = _useFormHelpers.populateFormData;
  var processedInitialValues = convertOrderSearchJsonToFormData(initialValues);
  var from = processedInitialValues.from,
    to = processedInitialValues.to,
    xid = processedInitialValues.xid,
    orderTitle = processedInitialValues.orderTitle;
  useEffect(function () {
    populateFormData(processedInitialValues);
  }, []);
  if (!from && !to && !xid && !orderTitle && orderCount === 0) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Form, {
    className: "row align-items-start",
    methods: methods,
    onSubmit: preprocessData(convertFormDataToOrderSearchJson, onSubmit)
  }, /*#__PURE__*/React.createElement(Text, {
    placeholder: "Order #",
    name: "xid",
    styles: {
      wrapper: 'mb-3 col-auto col-sm-3'
    }
  }), /*#__PURE__*/React.createElement(Text, {
    placeholder: "Order Title",
    name: "orderTitle",
    styles: {
      wrapper: 'mb-3 col-auto col-sm-3'
    }
  }), /*#__PURE__*/React.createElement(Datepicker, {
    isClearable: true,
    name: "from",
    placeholder: "From",
    popperPlacement: "bottom-start",
    styles: {
      wrapper: 'mb-3 col-auto col-sm-2'
    }
  }), /*#__PURE__*/React.createElement(Datepicker, {
    isClearable: true,
    name: "to",
    popperPlacement: "bottom-end",
    placeholder: "To",
    styles: {
      wrapper: 'mb-3 col-auto col-sm-2'
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "mb-3 col-12 col-sm-2"
  }, /*#__PURE__*/React.createElement("button", {
    "aria-label": t('Search'),
    type: "submit",
    className: "btn btn-primary btn-squared"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Search"
  })), /*#__PURE__*/React.createElement("button", {
    "aria-label": t('Clear'),
    type: "button",
    className: "clear-search ms-2",
    onClick: function onClick() {
      return onSubmit(defaultValues);
    }
  }, /*#__PURE__*/React.createElement(T, {
    source: "Clear"
  }))));
};
export default OrderSearchForm;